export default (state = {}, action = {}) => {
    if (action.type === 'GET_CHILD_CATEGORY') {
        return action.payload;
    }
    return state;
}